module.exports = __webpack_public_path__ + "img/no-followers.6b06ecf2.png";